import { defineComponent, PropType } from "vue";
import { IContactInfo } from "../../../interfaces/i-contact-info-card";

export default defineComponent({
    props: {
        contactInformation: { type: Object as PropType<IContactInfo>, default: {} }
    }
});
